import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableNetwork } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyAEIq8JQkJh9nu2yvnGTLuoiSLQzcnvM2E",
    authDomain: "elef89-af7b0.firebaseapp.com",
    projectId: "elef89-af7b0",
    storageBucket: "elef89-af7b0.firebasestorage.app",
    messagingSenderId: "636752014997",
    appId: "1:636752014997:web:1a747cf765c77db444f59c",
    measurementId: "G-XSDP9B9L96"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

// Force Firestore to reconnect when browser comes online
if (typeof window !== 'undefined') {
  window.addEventListener('online', async () => {
    console.log('Network is back online, reconnecting Firestore...');
    try {
      await enableNetwork(db);
      console.log('Firestore reconnected successfully');
    } catch (error) {
      console.warn('Error reconnecting Firestore:', error.message);
    }
  });

  // Also try to ensure Firestore is connected on page load
  // This helps if the client was marked as offline incorrectly
  if (navigator.onLine) {
    enableNetwork(db).catch(err => {
      console.warn('Initial Firestore network enable failed:', err.message);
    });
  }
}

// Export Firebase services
export const auth = getAuth(app);
export { db };
export const functions = getFunctions(app);
export { analytics };
export default app; 